import { IntlShape } from 'react-intl';

import CommonMessages from '~/core/commonMessages';

export const getGameNumberLabel = (intl: IntlShape, gameCount: number | null, ifNecessary: boolean): string => {
    if (!gameCount) {
        return '';
    }

    const gameMessage = ifNecessary
        ? CommonMessages.playoffGameDescriptions.descriptions.gameIfNecessary
        : CommonMessages.playoffGameDescriptions.descriptions.game;

    return intl.formatMessage(gameMessage, { gameCount });
};
